export default "__VITE_ASSET__DlGJRtMH__"